module.exports = __webpack_public_path__ + "9663b85e.png";